import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=24c67725&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c67725')) {
      api.createRecord('24c67725', component.options)
    } else {
      api.reload('24c67725', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=24c67725&", function () {
      api.rerender('24c67725', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/Form.vue"
export default component.exports